<template>
  <div class="preparation-activity">
    <div class="preparation-activity-top">
        <div class="title">备课活动概览</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="preparation-activity-tab">
      <div class="tab-left">
        <div class="subject" @click="changeTab(true)" :class="isSelectSubject ? 'is-active':''">
          按学科
        </div>
        <div class="grade" @click="changeTab(false)" :class="!isSelectSubject ? 'is-active':''">
          按年级
        </div>
      </div>
    </div>
    <div class="preparation-activity-echarts">
      <div style="width: 100%;height: 100%" id="preparationEchartsId"></div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
import axios from 'axios';
export default {
  name: 'preparation-activity',
  data() {
    return {
      subjectId:"0",
      isSelectSubject:true,
      subjectList:[
        {
          "name":"语文",
          "number":"30.95",
          "value":13
        },
        {
          "name":"数学",
          "number":"30.95",
          "value":13
        },
        {
          "name":"生物",
          "number":"16.67",
          "value":7
        },
        {
          "name":"思品",
          "number":"7.14",
          "value":3
        },
        {
          "name":"历史",
          "number":"4.76",
          "value":2
        },
        {
          "name":"计算机科学与技术",
          "number":"2.38",
          "value":1
        },
        {
          "name":"体育",
          "number":"2.38",
          "value":1
        },
        {
          "name":"物理",
          "number":"2.38",
          "value":1
        },
        {
          "name":"跨学科",
          "number":"2.38",
          "value":1
        }
      ],
      gradeList:[
        {
          "name":"七年级",
          "number":"62.26",
          "value":33
        },
        {
          "name":"八年级",
          "number":"20.75",
          "value":11
        },
        {
          "name":"九年级",
          "number":"13.21",
          "value":7
        },
        {
          "name":"跨年级",
          "number":"3.77",
          "value":2
        }
      ],
      phaseList:[
          {
              value:500,
              name:'小学',
              number:50
          },
          {
              value:250,
              name:'初中',
              number:25
          },
          {
              value:250,
              name:'高中',
              number:25
          }
      ]
    }
  },
  methods: {
    changeTab(value){
      this.isSelectSubject = value;

      echarts.init(document.getElementById('preparationEchartsId')).dispose()
      if(value){
        this.initEcharts(this.subjectList);
      }else{
        this.initEcharts(this.gradeList);
      }
    },
    initEcharts(dataList){
      let dom = document.getElementById('preparationEchartsId')
      let myChart = echarts.init(dom)
      let option;
      option = {
          tooltip: {
              trigger: 'item',
              // show: false,
              // 数据的显示方式
              formatter: (param) => {
                  return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
              }
          },
          legend: {
              selectedMode: false, // 是否允许点击
              pageIconColor: '#fff',
              pageIconInactiveColor: '#495D90',
              type: 'scroll',
              orient: 'vertical',
              right: 20,
              top: 25,
              bottom: 0,
              padding: 3, //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
              itemGap: 10, //图例每项之间的间隔
              itemWidth: 9, //图例标记的图形宽度
              itemHeight: 9,
              formatter: (name) => {
                  const data = dataList.find((item)=>{
                      return item.name == name;
                  })
                  let displayName = name;
                  if (name.length >5) { // 如果名称超过10个字符
                  displayName = name.slice(0, 5) + '...'; // 截取前10个字符并添加省略号
                }
                  return `{name|${displayName}}{percent|${data.number || 0}%}{count|${data.value || 0}}`;
              },
              textStyle: {
                  rich: {
                      name: {
                          fontSize: 14,
                          verticalAlign: 'right',
                          align: 'left',
                          color:"#6ea0d3",
                          width: 90
                      },
                      percent: {
                          fontSize: 14,
                          align: 'left',
                          color:"#23448a",
                          width: 60
                      },
                      count: {
                          fontSize: 14,
                          color:"#23448a",
                          align: 'left'
                      }
                  },
                  color: '#909399',
                  borderWidth: 2
              },
          },
          series: [
              {
                  type: 'pie',
                  radius: ['40%', '70%'],
                  center: ['20%', '45%'],
                  avoidLabelOverlap: false,
                  color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                  label: {
                      show: false,
                      position: 'center',
                      formatter: (data) => {
                          return (
                          "{a|" +
                          data.data.number +
                          "%}" +
                          "\r\n" +
                          "{b|" +
                          data.data.name +
                          "}"
                          );
                      },
                      rich: {
                          a: {
                              fontSize: 16,
                              lineHeight: 20,
                              color: "#fff",
                              align: "center",
                              fontWeight: "bold",
                          },
                          b: {
                              fontSize: 12,
                              lineHeight: 16,
                              fontWeight: "bold",
                              color: "#7ABFDB",
                              align: "center",
                          },
                      },
                      backgroundColor: "transparent",
                      fontWeight: "bold",
                      fontSize: "15",
                      padding: 6,
                  },
                  emphasis: {
                      label: {
                      show: true,
                      fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: dataList
              }
          ]
      };
      option && myChart.setOption(option)
    },
  },
  mounted(){
    this.changeTab(this.isSelectSubject);
  }
}
</script>
<style lang='scss' scoped>
  .preparation-activity{
    width: 100%;
    height: 270px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .preparation-activity-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .preparation-activity-tab{
      .tab-left{
        display: flex;
        align-items: center;
        .subject,.grade{
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #BFD5ED;
          padding-bottom: 10px;
          border-bottom: 2px solid transparent;
          margin-right: 40px;
          cursor: pointer;
        }
        .grade{
          margin-right: 0;
        }
        .is-active{
          border-color: #2773E6;
          color: #2773E6;
        }
      }
    }
    .preparation-activity-echarts{
      width: 100%;
      height: calc(100% - 95px);
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
  }
</style>